export enum VatDeclarationsTableStaticActionType {
  Export = 'export',
  RegisterPayment = 'registerPayment',
  Settle = 'settle',
  SubmitManually = 'submitManually',
  VoidPayment = 'voidPayment',
  VoidSettlement = 'voidSettlement',
}
